export const WELCOME_MESSAGES = [
  'You look good today,',
  'Make today a bop,',
  'Good to see you again,',
  'Welcome back,',
  "Let's make some magic,",
]
